/* ==========================================================================
   Rook UI Core — Quantity Selector Controller
   Web Component: <rk-quantity-selector>
   ========================================================================== */

if (!customElements.get('rk-quantity-selector')) {
    class RkQuantitySelector extends HTMLElement {
        constructor() {
            super();
            this.input = null;
            this.btnMinus = null;
            this.btnPlus = null;
        }

        connectedCallback() {
            this.input = this.querySelector('.rk-quantity__input');
            this.btnMinus = this.querySelector('[data-type="minus"]');
            this.btnPlus = this.querySelector('[data-type="plus"]');

            if (!this.input) return;

            this.bindEvents();
            this.updateButtons();
        }

        bindEvents() {
            this.btnMinus?.addEventListener('click', () => this.step(-1));
            this.btnPlus?.addEventListener('click', () => this.step(1));

            this.input.addEventListener('change', () => {
                this.clampValue();
                this.updateButtons();
                this.dispatchChange();
            });

            // Prevent non-numeric input
            this.input.addEventListener('keydown', (e) => {
                if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
                    e.preventDefault();
                }
            });
        }

        step(direction) {
            const stepValue = parseInt(this.input.step) || 1;
            const current = parseInt(this.input.value) || 1;
            const newValue = current + (stepValue * direction);

            this.input.value = newValue;
            this.clampValue();
            this.updateButtons();
            this.dispatchChange();
        }

        clampValue() {
            const min = parseInt(this.input.min) || 1;
            const max = this.input.max ? parseInt(this.input.max) : Infinity;
            let value = parseInt(this.input.value) || min;

            value = Math.max(min, Math.min(max, value));
            this.input.value = value;
        }

        updateButtons() {
            const value = parseInt(this.input.value) || 1;
            const min = parseInt(this.input.min) || 1;
            const max = this.input.max ? parseInt(this.input.max) : Infinity;

            if (this.btnMinus) {
                this.btnMinus.disabled = value <= min;
            }
            if (this.btnPlus) {
                this.btnPlus.disabled = value >= max;
            }
        }

        dispatchChange() {
            this.dispatchEvent(
                new CustomEvent('rk:quantity:change', {
                    bubbles: true,
                    detail: {
                        value: parseInt(this.input.value),
                        name: this.input.name,
                    },
                })
            );
        }
    }

    customElements.define('rk-quantity-selector', RkQuantitySelector);
}
